import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

export const sup: SugarElementInfo = { name: "sup", availableChildren: { type: AvailableChildrenType.Any } };
